<template>
    <div class="ModalDetalhes">
        <b-modal ref="modal-detalhes"
                 id="modalDetalhes"
                 size="xl"
                 hide-footer
                 hide-header
                 centered
                 body-class="p-0">

            <div class="md-wrapper">

                <button class="md-btn-close" @click="hideModalFn" type="button" aria-label="Fechar">
                    <i class="fas fa-times"></i>
                </button>

                <div class="md-header" :class="{ rolou: rolou }">
                    <div class="md-header__id">
                        <span class="md-header__badge" v-if="dados && dados.cdConteudo">
                            <i :class="getConteudoIcon(dados.cdConteudo)"></i>
                            {{ getConteudoNome(dados.cdConteudo) }}
                        </span>
                        <h2 class="md-header__title">{{ tituloExibido }}</h2>
                    </div>

                </div>

                <div class="md-body" ref="corpo" @scroll="onScrollCorpo">
                    <template v-if="dados && dados.cdConteudo == 'Arquivo'">
                        <div class="md-iframe-wrap">
                            <iframe :src="dados.dsReferencia" class="md-iframe"></iframe>
                        </div>
                    </template>

                    <template v-else>
                        <div class="md-loading" v-if="!componente && dataResult === null">
                            <div class="md-loading__spinner"></div>
                            <span>Carregando conteúdo…</span>
                        </div>

                        <div class="md-notfound" v-else-if="dataResult === 'NotFound'">
                            <strong>Nenhum conteúdo encontrado</strong>
                            <p>Nenhum conteúdo encontrado para este item.</p>
                        </div>

                        <component v-else-if="componente" :is="componente" :dados="dataResult" :busca="dados"></component>
                    </template>
                </div>

            </div>

        </b-modal>
    </div>
</template>

<script>
    import viewACORD from '@/components/Ferramentas/Pesquisa/viewACORD'
    import viewAUDIO from '@/components/Ferramentas/Pesquisa/viewAUDIO'
    import viewBOLET from '@/components/Ferramentas/Pesquisa/viewBOLET'
    import viewJURIS from '@/components/Ferramentas/Pesquisa/viewJURIS'
    import viewLFSIS from '@/components/Ferramentas/Pesquisa/viewLFSIS'
    import viewLGEST from '@/components/Ferramentas/Pesquisa/viewLGEST'
    import viewLGFED from '@/components/Ferramentas/Pesquisa/viewLGFED'
    import viewLGMUN from '@/components/Ferramentas/Pesquisa/viewLGMUN'
    import viewLICIT from '@/components/Ferramentas/Pesquisa/viewLICIT'
    import viewMODEL from '@/components/Ferramentas/Pesquisa/viewMODEL'
    import viewNOTIC from '@/components/Ferramentas/Pesquisa/viewNOTIC'
    import viewORIJU from '@/components/Ferramentas/Pesquisa/viewORIJU'
    import viewPERIO from '@/components/Ferramentas/Pesquisa/viewPERIO'
    import viewPUBLI from '@/components/Ferramentas/Pesquisa/viewPUBLI'
    import viewSUMUL from '@/components/Ferramentas/Pesquisa/viewSUMUL'
    import viewVIDEO from '@/components/Ferramentas/Pesquisa/viewVIDEO'
    import viewLEICO from '@/components/Ferramentas/Pesquisa/viewLEICO'
    import viewACSTF from '@/components/Ferramentas/Pesquisa/viewACSTF'
    import viewJUSTF from '@/components/Ferramentas/Pesquisa/viewJUSTF'
    import viewBOSTF from '@/components/Ferramentas/Pesquisa/viewBOSTF'
    import viewSUSTF from '@/components/Ferramentas/Pesquisa/viewSUSTF'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalDetalhes',
        components: {
            viewACORD, viewAUDIO, viewBOLET, viewJURIS,
            viewLFSIS, viewLGEST, viewLGFED, viewLGMUN,
            viewLICIT, viewMODEL, viewNOTIC, viewORIJU,
            viewPERIO, viewPUBLI, viewSUMUL, viewVIDEO,
            viewLEICO, viewACSTF, viewJUSTF, viewBOSTF, viewSUSTF
        },
        props: {
            dados: Object,
            showModal: Boolean,
            titulo: {
                type: String,
                default: 'Sollicita Pesquisa'
            },
        },
        computed: {
            tituloExibido() {
                const lei = this.dataResult && this.dataResult.legislacao && this.dataResult.legislacao.nmTitulo
                return lei || this.titulo
            },
        },
        data() {
            return {
                componente: null,
                dataResult: null,
                rolou: false,
                conteudoMap: {
                    'ACORD': { icon: 'far fa-newspaper', nome: 'Acórdão TCU' },
                    'AUDIO': { icon: 'fas fa-volume-up', nome: 'Áudio' },
                    'BOLET': { icon: 'fas fa-file-alt', nome: 'Boletim TCU' },
                    'JURIS': { icon: 'fas fa-file', nome: 'Jurisprudência TCU' },
                    'LFSIS': { icon: 'far fa-newspaper', nome: 'Legislação Sistema S' },
                    'LGEST': { icon: 'far fa-newspaper', nome: 'Legislação Estadual' },
                    'LGFED': { icon: 'far fa-newspaper', nome: 'Legislação Federal' },
                    'LGMUN': { icon: 'far fa-newspaper', nome: 'Legislação Municipal' },
                    'MODEL': { icon: 'far fa-newspaper', nome: 'Modelo' },
                    'NOTIC': { icon: 'far fa-newspaper', nome: 'Notícia' },
                    'ORIJU': { icon: 'far fa-newspaper', nome: 'Orientação Técnica' },
                    'PERIO': { icon: 'far fa-newspaper', nome: 'Periódico' },
                    'PUBLI': { icon: 'far fa-newspaper', nome: 'Publicação' },
                    'SUMUL': { icon: 'far fa-newspaper', nome: 'Súmula TCU' },
                    'VIDEO': { icon: 'far fa-play-circle', nome: 'Vídeo' },
                    'MATER': { icon: 'far fa-newspaper', nome: 'Doutrina' },
                    'LEICO': { icon: 'far fa-newspaper', nome: 'Lei Comentada' },
                    'ACSTF': { icon: 'far fa-newspaper', nome: 'Acórdão STF' },
                    'JUSTF': { icon: 'far fa-newspaper', nome: 'Jurisprudência STF' },
                    'BOSTF': { icon: 'far fa-newspaper', nome: 'Boletim STF' },
                    'SUSTF': { icon: 'far fa-newspaper', nome: 'Súmula STF' },
                    'Arquivo': { icon: 'fas fa-file-pdf', nome: 'Arquivo' },
                },
            }
        },
        methods: {
            getConteudoIcon(cd) {
                const item = this.conteudoMap[cd]
                return item ? item.icon : 'fas fa-file'
            },
            getConteudoNome(cd) {
                const item = this.conteudoMap[cd]
                return item ? item.nome : cd
            },
            onScrollCorpo(e) {
                this.rolou = e.target.scrollTop > 70
            },
            load() {
                let $this = this
                $this.componente = null
                $this.dataResult = null
                $this.rolou = false

                axios.get(`${urlApi}/Pesquisa/view${$this.dados.cdConteudo}`, {
                    params: {
                        idItemPesquisa: $this.dados.idItemPesquisa,
                        dsReferencia: $this.dados.dsReferencia,
                        idLogPesquisa: $this.dados.idLogPesquisa,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data) {
                                $this.dataResult = res.data.data
                                $this.componente = 'view' + $this.dados.cdConteudo
                                $this.$refs['modal-detalhes'].show()
                            } else {
                                $this.dataResult = 'NotFound'
                                $this.$refs['modal-detalhes'].show()
                            }
                        } else {
                            avisoErro('Não foi possível carregar view')
                        }
                    })
                    .catch(() => {
                        avisoErro('Não foi possível carregar view')
                    })
            },
            loadArquivo() {
                this.$refs['modal-detalhes'].show()
            },
            hideModalFn() {
                this.$refs['modal-detalhes'].hide()
            }
        },
        watch: {
            showModal() {
                if (this.dados.cdConteudo != 'Arquivo') {
                    this.load()
                } else {
                    this.loadArquivo()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;600;700&family=Lora:ital,wght@0,400;0,600;1,400&display=swap');
    @import "@/assets/css/lei-comentada/variaveis";

    :deep(.modal-backdrop) {
        background: $sol-scrim;
        opacity: 1 !important;
    }
    :deep(.modal-dialog) {
        max-width: 1120px;
        overflow: visible;
        margin: auto;
    }
    :deep(.modal-content) {
        background: transparent;
        border: 0;
        box-shadow: none;
        overflow: visible;
    }
    :deep(.modal-body) {
        padding: 0;
        overflow: visible;
    }

    .md-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: calc(100vh - 72px);
        overflow: visible;
        background: $sol-papel;
        border-radius: $sol-raio;
        box-shadow: $sol-sombra-modal;
        font-family: $sol-ui;
        color: $sol-texto;
    }

    .md-btn-close {
        position: absolute;
        top: -19px;
        right: -19px;
        z-index: 5;
        display: grid;
        place-items: center;
        width: 44px;
        height: 44px;
        border: 1px solid $sol-linha;
        border-radius: 50%;
        background: $sol-papel;
        color: $sol-texto;
        font-size: 19px;
        line-height: 1;
        cursor: pointer;
        box-shadow: 0 6px 18px rgba(25, 25, 50, 0.22);
        transition: transform 0.15s ease, color 0.15s ease;
        padding: 0;

        &:hover { transform: scale(1.06); color: $sol-ouro; }
        @include sol-foco;
    }

    .md-header {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: none;
        height: 66px;
        padding: 0 24px;
        background: $sol-papel;
        border-bottom: 1px solid $sol-linha;
        border-radius: $sol-raio $sol-raio 0 0;

        &__id {
            display: flex;
            align-items: center;
            gap: 14px;
            flex: 1;
            min-width: 0;
        }

        &__badge {
            display: inline-flex;
            align-items: center;
            gap: 7px;
            flex: none;
            padding: 5px 10px;
            border: 1px solid $sol-ouro-borda;
            border-radius: 7px;
            background: $sol-ouro-fundo;
            color: $sol-ouro;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.13em;
            text-transform: uppercase;

            i { font-size: 12px; }
        }

        &__title {
            margin: 0;
            font-family: $sol-serif;
            font-size: 17px;
            font-weight: 600;
            color: $sol-texto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            opacity: 0;
            transform: translateY(6px);
            transition: opacity 0.22s ease, transform 0.22s ease;
        }

        &.rolou &__title { opacity: 1; transform: none; }

        &__ref {
            margin: 0;
            font-size: 12.5px;
            color: $sol-texto-3;
        }
    }

    .md-body {
        flex: 1 1 auto;
        overflow: auto;
        background: $sol-papel;
        scroll-behavior: smooth;
        border-radius: 0 0 $sol-raio $sol-raio;
        max-height: calc(100vh - 72px - 66px);
    }

    .md-loading,
    .md-notfound {
        display: grid;
        place-items: center;
        gap: 12px;
        min-height: 320px;
        padding: 40px 24px;
        color: $sol-texto-3;
        font-size: 14.5px;
        text-align: center;
    }
    .md-notfound strong {
        font-family: $sol-serif;
        font-size: 19px;
        font-weight: 600;
        color: $sol-texto;
    }
    .md-loading__spinner {
        width: 38px;
        height: 38px;
        border: 3px solid $sol-linha;
        border-top-color: $sol-ouro;
        border-radius: 50%;
        animation: mdSpin 0.7s linear infinite;
    }
    @keyframes mdSpin {
        to { transform: rotate(360deg); }
    }

    .md-iframe-wrap {
        width: 100%;
        height: 65vh;
        background: $sol-papel;
    }
    .md-iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }

    :deep(.modal-footer) {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 8px;
        padding: 14px 20px 18px !important;
        background: $sol-papel;
        border-top: 1px solid $sol-linha;
        border-radius: 0;

        &:not(:has(button, a)) { display: none; }

        &:has(.origem) { justify-content: space-between; }

        .btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            min-height: 40px;
            margin: 0;
            padding: 0 16px;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 600;
            line-height: 1;
            text-decoration: none;
            white-space: nowrap;
            cursor: pointer;
            transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;

            &:active { transform: translateY(1px); }

            i { font-size: 13px; }
        }

        .btn-default {
            background: #fff;
            border: 1px solid #cbd5e1;
            color: #1e3a8a;

            &:hover {
                background: #eff6ff;
                border-color: #2563eb;
                color: #1d4ed8;
            }
        }

        .btn-blue,
        .btn-imprimir {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            border: none;
            color: #fff;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);

            &:hover {
                background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                color: #fff;
            }
        }
    }

    @media (max-width: 900px) {
        .md-wrapper { max-height: calc(100vh - 32px); }

        .md-btn-close { top: -14px; right: -10px; width: 38px; height: 38px; }

        .md-header {
            height: auto;
            padding: 14px 16px;
            flex-wrap: wrap;
            gap: 10px;

            &__title { white-space: normal; font-size: 16px; }
        }
    }

    @media print {
        :deep(.modal-backdrop) { display: none !important; }

        .md-btn-close,
        .md-header__badge { display: none !important; }

        .md-wrapper {
            display: block;
            max-width: none;
            max-height: none;
            border-radius: 0;
            box-shadow: none;
        }

        .md-header {
            height: auto;
            padding: 0 0 8px;
            margin-bottom: 18px;
            border-bottom: 1px solid #000;
        }
        .md-header__title {
            opacity: 1 !important;
            transform: none !important;
            white-space: normal;
            font-size: 15px;
        }

        .md-body { overflow: visible; background: #fff; max-height: none; }
    }
</style>
